/**
 * Super Admin — API Helper
 * Centraliza autenticação, interceptação de 401 e tipagem.
 */

const API_BASE = import.meta.env.VITE_API_URL || '';

/**
 * Fetch autenticado para o Super Admin.
 * - Injeta Authorization header com token do localStorage
 * - Intercepta 401 → limpa tokens e redireciona para login
 * - Se token não existe → redireciona imediatamente
 */
export async function superFetch(
  path: string,
  options?: RequestInit,
): Promise<Response> {
  const token = localStorage.getItem('superAdminToken');

  if (!token) {
    window.location.href = '/super-admin/login';
    throw new Error('Not authenticated');
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options?.headers || {}),
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('superAdminToken');
    localStorage.removeItem('superAdminRefreshToken');
    localStorage.removeItem('superAdminUser');
    window.location.href = '/super-admin/login';
  }

  return response;
}

/**
 * Formata valor monetário em pt-BR (R$)
 */
export function formatCurrency(value: number): string {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });
}

/**
 * Formata data ISO para pt-BR
 */
export function formatDate(isoDate: string): string {
  return new Date(isoDate).toLocaleDateString('pt-BR');
}
